import React from 'react';
import ReactDOM from 'react-dom';
import ReactDOMServer from 'react-dom/server';
import { OffersWidget } from './index';
import '~/styles/main.scss';

global.React = React;
global.ReactDOM = ReactDOM;
global.ReactDOMServer = ReactDOMServer;

// Name MUST match the Umbraco doctype's generated model class name (OffersWidget),
// which is what PortableComponent.cshtml passes to @Html.React(content.Content.GetType().Name, ...).
global.OffersWidget = OffersWidget;
